import type { App as VueApp, Plugin } from "vue";

import InfoRequest from "@LandingPage/Scripts/Components/InfoRequest/InfoRequest.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("lan-inforequest", InfoRequest);

        app.component("app-cookietoast", CookieToast);
    }
};

export default AppConfig;